<template>
  <el-menu
    class="demo-siderbar-menu"
    unique-opened
    router
    :default-active="checkKey"
    active-text-color="#295BFF"
  >
    <sub-menu
      v-for="item in sidebarData"
      :key="item.index"
      :menu="item"
    />
  </el-menu>
</template>
<script>
import SubMenu from './sub-menu.vue';
export default {
  name: 'DemoSiderbarUp',
  components: {
    SubMenu,
  },
  props: {
    sidebarData: {
      type: Array,
      default() {
        return [];
      }
    },
    checkKey: {
      type: String,
      default() {
        return '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.demo-siderbar-menu {
  padding: 0 10px;
  &.el-menu {
    border-right: none;
  }
  &::v-deep .el-submenu__title {
    height: 44px;
    line-height: 44px;
    font-weight: 500;
    color: #10131F;
    .el-submenu__icon-arrow.el-icon-arrow-down::before {
      content: "\e790";
      color: #757575;
    }
  }
  &::v-deep .el-menu-item {
    height: 44px;
    line-height: 44px;
    color: #41444D;
    &.is-active {
      background-color: rgba(41, 91, 255, 0.1);
      border-radius: 3px;
    }
  }
}
</style>
<style lang="scss">
.demo-siderbar-menu .collapse-transition {
  transition: 0s;
}
</style>
